<template>
  <div
    class="relative flex w-full flex-grow flex-col items-center justify-center"
  >
    <img
      src="@/assets/images/no-search-results.svg"
      alt="Нет результатов"
      width="211"
      height="213"
      class="mb-9"
    />
    <div class="mb-9 space-y-3 text-center">
      <p class="text-text-neutral-primary text-2xl font-bold">
        {{
          $t('search.emptyResults.title', {
            date: searchEmptyResultsUtils.lib.getDatesText(
              props.departureDates,
            ),
          })
        }}
      </p>
      <p class="text-text-neutral-quaternary text-base font-medium">
        {{ $t('search.emptyResults.changeForm') }}
      </p>
    </div>
    <slot />
  </div>
</template>

<script setup lang="ts">
  import { searchEmptyResultsUtils } from 'shared';

  const props = defineProps<{
    departureDates: Array<string>;
  }>();
</script>
